import React from "react"
import { Chip } from "@mui/material"
import TerminalApplications from "./TerminalApplications"
import { assignedApps, installedApps, appSearchText } from "./terminalApplicationData"

const TerminalsColumns = () => [
  { accessorKey: "serialNo", header: "Serial #" },
  { accessorKey: "model", header: "Model" },
  { accessorKey: "orgName", header: "Organization" },
  { accessorKey: "groupName", header: "Group", Cell: ({ cell }) => cell.getValue() || "Unassigned" },
  // {
  //   id: "assignedApplications", header: "Assigned applications", size: 320,
  //   accessorFn: (row) => appSearchText(assignedApps(row)),
  //   enableSorting: false,
  //   Cell: ({ row }) => <TerminalApplications applications={assignedApps(row.original)} compact />,
  // },
  // {
  //   id: "installedApplications", header: "Installed applications", size: 300,
  //   accessorFn: (row) => appSearchText(installedApps(row)),
  //   enableSorting: false,
  //   Cell: ({ row }) => <TerminalApplications applications={installedApps(row.original)} installed compact />,
  // },
  {
    accessorKey: "status", header: "Terminal status",
    Cell: ({ cell }) => <Chip size="small" variant="outlined" label={cell.getValue() || "Not reported"}
      color={cell.getValue() === "ACTIVE" ? "success" : cell.getValue() === "INACTIVE" ? "error" : "default"} />,
  },
  {
    id: "connStatus", header: "Connection",
    accessorFn: (row) => row.sseConnectionDtl?.connStatus ?? row.connStatus ?? "Not reported",
    Cell: ({ cell }) => <Chip size="small" variant="outlined" label={cell.getValue()}
      color={cell.getValue() === "CONNECTED" ? "success" : cell.getValue() === "DISCONNECTED" ? "error" : "default"} />,
  },
]
export default TerminalsColumns
